var path = '/app/components/ui/interview-ballon/interview-ballon.html';
var html = "<div class=\"interview-ballon {{ $ctrl.type }}\" key={{$ctrl.key}}> <div class=interview-ballon-body> <div class=\"interview-ballon-text ng-hide\">{{ $ctrl.text}}</div> <a class=\"btn-play interview-ballon-btn-ok\" ng-class=\"{ 'disabled': $ctrl.playing}\" ng-click=$ctrl.finish()></a> </div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/ui/interview-ballon/interview-ballon.html
// module id = 168
// module chunks = 0